// ----------------------------------------------------------------------------
// Section: App Widget
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_app-widget.scss';
